export const businessConstants = {
    GET_BUSINESS_CASE_REQUEST: 'GET_BUSINESS_CASE_REQUEST',
    GET_BUSINESS_CASE_SUCCESS: 'GET_BUSINESS_CASE_SUCCESS',
    GET_BUSINESS_CASE_FAILURE: 'GET_BUSINESS_CASE_FAILURE',

    CREATE_BUSINESS_CASE_REQUEST: 'CREATE_BUSINESS_CASE_REQUEST',
    CREATE_BUSINESS_CASE_SUCCESS: 'CREATE_BUSINESS_CASE_SUCCESS',
    CREATE_BUSINESS_CASE_FAILURE: 'CREATE_BUSINESS_CASE_FAILURE',

    UPDATE_BUSINESS_CASE_REQUEST: 'UPDATE_BUSINESS_CASE_REQUEST',
    UPDATE_BUSINESS_CASE_SUCCESS: 'UPDATE_BUSINESS_CASE_SUCCESS',
    UPDATE_BUSINESS_CASE_FAILURE: 'UPDATE_BUSINESS_CASE_FAILURE',

    DELETE_BUSINESS_CASE_REQUEST: 'DELETE_BUSINESS_CASE_REQUEST',
    DELETE_BUSINESS_CASE_SUCCESS: 'DELETE_BUSINESS_CASE_SUCCESS',
    DELETE_BUSINESS_CASE_FAILURE: 'DELETE_BUSINESS_CASE_FAILURE',

    ASSEMBLE_BUSINESS_CASE_REQUEST: 'ASSEMBLE_BUSINESS_CASE_REQUEST',
    ASSEMBLE_BUSINESS_CASE_SUCCESS: 'ASSEMBLE_BUSINESS_CASE_SUCCESS',
    ASSEMBLE_BUSINESS_CASE_FAILURE: 'ASSEMBLE_BUSINESS_CASE_FAILURE',
    CLEAR_ASSEMBLED_BUSINESS_CASE: 'CLEAR_ASSEMBLED_BUSINESS_CASE',

    ASSEMBLE_BUSINESS_CASES_REQUEST: 'ASSEMBLE_BUSINESS_CASES_REQUEST',
    ASSEMBLE_BUSINESS_CASES_SUCCESS: 'ASSEMBLE_BUSINESS_CASES_SUCCESS',
    ASSEMBLE_BUSINESS_CASES_FAILURE: 'ASSEMBLE_BUSINESS_CASES_FAILURE',
    CLEAR_ASSEMBLED_BUSINESS_CASES: 'CLEAR_ASSEMBLED_BUSINESS_CASES',

    DELETE_SCENARIO_FROM_BUSINESS_CASES: 'DELETE_SCENARIO_FROM_BUSINESS_CASES',

    BUSINESS_SET_SELECTED_ID: 'BUSINESS_SET_SELECTED_ID',
    BUSINESS_CLEAR_SELECTED_ID: 'BUSINESS_CLEAR_SELECTED_ID',

};
